import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotFoundComponent } from "./not-found.component";

const routes: Routes = [
  { path: "", redirectTo: "/account", pathMatch: "full" },
  { path: "mysettings", redirectTo: "/account" },
  { path: "Dashboard", redirectTo: "/account" },
  { path: "**", component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}

//export const routedComponents = [NameComponent];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts